import lottyAnim from "./modules/lottyAnim";
import Header from "./modules/header";
import fancyPopups from "./modules/fancyPopups";
import redirectModal from "./modules/redirectModal";

document.addEventListener('DOMContentLoaded', function () {

    const lottieShapes = document.querySelectorAll('.lottieShapes');
    if (lottieShapes.length > 0) {
        const lottieShapesObserverOptions = {
            root: null,
            rootMargin: '200px',
            threshold: 0,
        };

        const lottieShapesIntersectionCallback = (entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const elem = entry.target;
                    lottyAnim(elem, true);
                    observer.unobserve(elem);
                }
            });
        };

        const lottieShapesIntersectionObserver = new IntersectionObserver(lottieShapesIntersectionCallback, lottieShapesObserverOptions);

        lottieShapes.forEach(function (elem) {
            lottieShapesIntersectionObserver.observe(elem);
        });
    }

    const header = new Header(document.querySelector('header.header'));
    header.init();

    // if (document.body.dataset.lang === 'en' && document.body.dataset.blogId === '3' && document.body.classList.contains('geoip-country-SE')) {
    //     redirectModal();
    // }

    fancyPopups();
});



// WEBPACK FOOTER //
// ./scripts/critical.js